import {setCookie} from "./setCookie";

export const setTheme = (setter, theme) => {
  setter(theme);
  document.documentElement.setAttribute("data-theme", theme);
  setCookie("data-theme", theme);
};
